import * as React from "react";
const SvgVickyFineartSendToPhotographer = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-fe410c78-1f70-46c7-a4c0-cf5e9976e261", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 94.93 58.56", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: ".82 16.13 93.66 1.48 60.04 54.74 45.81 45.17 29.06 33.9 30.18 57.06 17.67 27.12 .82 16.13", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("polyline", { points: "17.67 27.12 93.66 1.48 29.06 33.9", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("line", { x1: 30.18, y1: 57.06, x2: 45.81, y2: 45.17, style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 3
} }));
export default SvgVickyFineartSendToPhotographer;
